import { FC, PropsWithChildren, ReactElement } from 'react';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonModal,
  IonToolbar,
} from '@ionic/react';
import { useContextSelector } from 'use-context-selector';
import classNames from 'classnames';
import { useTheme } from 'styled-components';

import { DetailsContext } from '../Details.context';
import { ICONS_BASE64 } from '../../Icon';

import { DetailsContentFooterProps } from './DetailsContent.types';

import styles from './DetailsContent.module.scss';

type DetailsContentProps = PropsWithChildren<{
  breakpoint?: number;
  footer?: (props: DetailsContentFooterProps) => ReactElement;
}>;

export const DetailsContent: FC<DetailsContentProps> = ({
  children,
  footer,
  breakpoint = 1,
}) => {
  const { isMobile } = useTheme();

  const isOpen = useContextSelector(DetailsContext, ({ isOpen }) => isOpen);

  const close = useContextSelector(DetailsContext, ({ close }) => close);

  return (
    <IonModal
      keepContentsMounted={false}
      isOpen={isOpen}
      breakpoints={isMobile ? [0, breakpoint] : undefined}
      initialBreakpoint={isMobile ? breakpoint : undefined}
      className={classNames(styles.root, {
        [styles.mobile]: isMobile,
      })}
      handle={false}
    >
      <IonHeader className="ion-no-border">
        <IonToolbar>
          <IonButtons slot="end">
            <IonButton onClick={close} shape="round">
              <IonIcon icon={ICONS_BASE64.x} slot="icon-only" />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">{children}</IonContent>
      <IonFooter
        className={classNames({
          'ion-padding': !!footer,
          'ion-no-border': !footer,
        })}
      >
        {!!footer && <IonToolbar>{footer({ close })}</IonToolbar>}
      </IonFooter>
    </IonModal>
  );
};
